// This is a wrapper around promises that allows you to avoid nested
// try catch blocks in a single function.
export const tryCatch = (promise: Promise<any>) => {
  return promise
    .then((data) => [null, data])
    .catch((err) => {
      return [err]; // which is same as [err, undefined];
    });
};
